import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Summary from './summary'
import CreditSummaryBar from '../credit-summary-bar'

const Wrapper = styled.div`
  > :not(:last-child) {
    margin-bottom: 16px;
  }
`
const CreditSummaryView = ({ data, isLocked, isLoading }) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <CreditSummaryBar data={data} isLoading={isLoading} isLocked={isLocked} />

      <Summary
        data={data?.revolving}
        title={t('l.application.view.revolving.label', 'Revolving')}
        defaultOpen
        isLocked={isLocked}
        isLoading={isLoading}
      />
      <Summary
        data={data?.installment}
        title={t('l.application.view.instalment.label', 'Instalment')}
        isLocked={isLocked}
        isLoading={isLoading}
      />
      <Summary
        data={data?.mortgage}
        title={t('l.application.view.mortgage.label', 'Mortgage')}
        isLocked={isLocked}
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

export default CreditSummaryView
